import { render } from "./ContratosRegistro.vue?vue&type=template&id=6f5adb34"
import script from "./ContratosRegistro.vue?vue&type=script&lang=js"
export * from "./ContratosRegistro.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__